module.exports = __webpack_public_path__ + "img/园区.37b716cb.png";